<template>
  <div>
    <div v-if="!disabled">
      <SelectTableDialog
        :title="$t('contractAgency.relationTab.dialogTitle')"
        :searchColumns="searchColumns"
        :columnList="searchList"
        :API="API"
        :extraData="extraData"
        width="1000px"
        ref="relationInfo"
        @confirm="confirm"
        propCode="contractNo"
        :checkRowKeys="checkRowKeys"
      >
        <vxe-button size="mini" type="primary" class="vxe-btn-primary" icon="el-icon-plus">
          {{ $t('contractAgency.relationTab.openButton') }}
        </vxe-button>
      </SelectTableDialog>
      <vxe-button
        size="mini"
        @click="handleDelete"
        type="primary"
        class="vxe-btn-delete"
        icon="el-icon-delete"
      >
        {{ $t('contractAgency.relationTab.deleteBtn') }}
      </vxe-button>
    </div>
    <vxe-table
      border
      show-overflow
      resizable
      :auto-resize="true"
      ref="table"
      class="vxe-table-element m-t-sm"
      size="mini"
      :data="tableData"
      @cell-dblclick="dblclickEvent"
    >
      <vxe-table-column v-if="!disabled" type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :type="item.type"
        :key="index"
        :fixed="item.fixed"
        :field="item.prop"
        :title="item.label"
        :width="item.width"
        :sortable="item.sortable"
      >
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import SelectTableDialog from '@/components/SelectTableDialog';
  import AGENCY_API from '@/api/agencyContract/index';
  import { handleContractEditPath } from '@/common/js/contract';

  export default {
    components: {
      SelectTableDialog,
    },
    props: {
      defaultData: {
        type: Array,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      contractNo: {
        type: String,
        default: '',
      },
    },
    watch: {
      // 将默认值给表格数据
      defaultData() {
        this.checkRowKeys = this.defaultData.map((item) => {
          return item.relatedContractNo;
        });
        this.tableData = this.defaultData.slice();
      },
    },
    data() {
      return {
        API: AGENCY_API.LIST_CONTRACT,
        tableData: [],
        checkRowKeys: [],
        extraData: {
          contractStatus: 'ZT03',
        },
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            prop: 'contractNo',
            name: this.$t('salePurchase.search.contractNo'),
            type: 'input',
            maxlength: 50,
            placeholder: this.$t('salePurchase.search.contractNoPlaceholder'),
          },
        ];
      },
      // 表格展示数据
      columnList() {
        return [
          { type: 'seq', label: this.$t('contractAgency.relationTab.index'), width: 80 },
          { prop: 'relatedContractNo', label: this.$t('contractAgency.relationTab.number') },
          { prop: 'relatedContractTypeName', label: this.$t('contractAgency.relationTab.type') },
          {
            prop: 'relatedContractCreateDate',
            label: this.$t('contractAgency.relationTab.createTime'),
          },
          { prop: 'relationshipIdentity', label: this.$t('contractAgency.relationTab.identify') },
        ];
      },
      // 搜索表格列表
      searchList() {
        return [
          { prop: 'contractNo', label: this.$t('contractAgency.relationTab.number') },
          { prop: 'contractDetailCategoryName', label: this.$t('contractAgency.relationTab.type') },
          { prop: 'contractCreateDate', label: this.$t('contractAgency.relationTab.createTime') },
        ];
      },
    },
    methods: {
      handleContractEditPath,
      confirm(multipleSelection) {
        const list = multipleSelection.map((item) => {
          // 给需要的值给表格展示
          return {
            relatedContractNo: item.contractNo,
            relatedContractType: item.contractDetailCategory,
            relatedContractTypeName: item.contractDetailCategoryName,
            relatedContractCreateDate: item.contractCreateDate,
            relationshipType: item.contractCategory,
          };
        });
        this.tableData = list.slice();
        // 关闭弹窗
        this.$refs.relationInfo.dialogVisible = false;
      },
      // 获取关联明细
      getValues() {
        const allData = this.$refs['table'].getTableData();
        return allData.tableData.map((item) => {
          const result = Object.assign({}, item);
          if (this.contractNo) {
            result.contractNo = this.contractNo;
          }
          delete result.id;
          return result;
        });
      },
      //双击单元格事件
      dblclickEvent(value) {
        this.handleContractEditPath(
          value.row.relatedContractType,
          value.row.relatedContractNo,
          value.row.contractId,
          true
        );
      },
      handleDelete() {
        const selectedList = this.$refs['table'].getCheckboxRecords(); // 选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs['table'].removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.success'),
            });
            this.checkRowKeys = this.getValues().map((item) => {
              return item.relatedContractNo;
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancle'),
            });
          });
      },
    },
  };
</script>
